var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelAudio = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M10.477 6.134 6.034 9.469h-2.02C3.441 9.47 3 9.922 3 10.482v3.037a1.01 1.01 0 0 0 1.013 1.012h2.02l4.444 3.336.038.007c1.087.203 1.58.295 1.58-.804V6.93c0-1.098-.492-1.007-1.574-.805zm5.084 2.782c-.37-.244-.885-.166-1.15.175-.266.341-.18.816.19 1.06.652.43 1.042 1.12 1.042 1.848 0 .73-.39 1.42-1.042 1.851-.37.244-.456.718-.19 1.059.16.207.415.317.67.317a.87.87 0 0 0 .48-.142c1.083-.714 1.731-1.867 1.731-3.085 0-1.215-.648-2.369-1.73-3.083m1.534-2.308a.873.873 0 0 1 1.164-.082C20 7.9 21 9.896 21 12s-1 4.1-2.741 5.474a.86.86 0 0 1-.537.184.85.85 0 0 1-.627-.267.718.718 0 0 1 .09-1.07c1.376-1.085 2.166-2.66 2.166-4.322 0-1.659-.79-3.235-2.166-4.32a.72.72 0 0 1-.09-1.071",
  clipRule: "evenodd"
})));
export default SvgGemChannelAudio;